var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useField } from 'formik';
import MultipleAddressField from '../forms/MultipleAddressField';
export default (function (_a) {
    var props = __rest(_a, []);
    var _b = useField("".concat(props.firstAddressField.name, "Address")), firstAddressField = _b[0], firstAddressMeta = _b[1], firstAddressFieldHelper = _b[2];
    var _c = useField("".concat(props.firstAddressField.name, "SuiteAptNumber")), firstSuiteAptNumberField = _c[0], firstSuiteAptNumberMeta = _c[1], firstSuiteAptNumberFieldHelper = _c[2];
    var _d = useField("".concat(props.firstAddressField.name, "City")), firstCityField = _d[0], firstCityMeta = _d[1], firstCityFieldHelper = _d[2];
    var _e = useField("".concat(props.firstAddressField.name, "State")), firstStateField = _e[0], firstStateMeta = _e[1], firstStateFieldHelper = _e[2];
    var _f = useField("".concat(props.firstAddressField.name, "Zip")), firstZipField = _f[0], firstZipMeta = _f[1], firstZipFieldHelper = _f[2];
    var firstAddressInvalid = function () {
        return firstAddressMeta.touched && !!firstAddressMeta.error;
    };
    var firstSuiteAptNumberInvalid = function () {
        return firstSuiteAptNumberMeta.touched && !!firstSuiteAptNumberMeta.error;
    };
    var firstCityInvalid = function () {
        return firstCityMeta.touched && !!firstCityMeta.error;
    };
    var firstStateInvalid = function () {
        return firstStateMeta.touched && !!firstStateMeta.error;
    };
    var firstZipInvalid = function () {
        return firstZipMeta.touched && !!firstZipMeta.error;
    };
    var firstIsInvalid = function () {
        return firstAddressInvalid() ||
            firstSuiteAptNumberInvalid() ||
            firstCityInvalid() ||
            firstStateInvalid() ||
            firstZipInvalid();
    };
    var _g = useField("".concat(props.secondAddressField.name, "Address")), secondAddressField = _g[0], secondAddressMeta = _g[1], secondAddressFieldHelper = _g[2];
    var _h = useField("".concat(props.secondAddressField.name, "SuiteAptNumber")), secondSuiteAptNumberField = _h[0], secondSuiteAptNumberMeta = _h[1], secondSuiteAptNumberFieldHelper = _h[2];
    var _j = useField("".concat(props.secondAddressField.name, "City")), secondCityField = _j[0], secondCityMeta = _j[1], secondCityFieldHelper = _j[2];
    var _k = useField("".concat(props.secondAddressField.name, "State")), secondStateField = _k[0], secondStateMeta = _k[1], secondStateFieldHelper = _k[2];
    var _l = useField("".concat(props.secondAddressField.name, "Zip")), secondZipField = _l[0], secondZipMeta = _l[1], secondZipFieldHelper = _l[2];
    var secondAddressInvalid = function () {
        return secondAddressMeta.touched && !!secondAddressMeta.error;
    };
    var secondSuiteAptNumberInvalid = function () {
        return secondSuiteAptNumberMeta.touched && !!secondSuiteAptNumberMeta.error;
    };
    var secondCityInvalid = function () {
        return secondCityMeta.touched && !!secondCityMeta.error;
    };
    var secondStateInvalid = function () {
        return secondStateMeta.touched && !!secondStateMeta.error;
    };
    var secondZipInvalid = function () {
        return secondZipMeta.touched && !!secondZipMeta.error;
    };
    var secondIsInvalid = function () {
        return secondAddressInvalid() ||
            secondSuiteAptNumberInvalid() ||
            secondCityInvalid() ||
            secondStateInvalid() ||
            secondZipInvalid();
    };
    return React.createElement(MultipleAddressField, { className: props.className, sameAsLabel: props.sameAsLabel, firstAddressField: __assign(__assign({}, props.firstAddressField), { errorMessage: firstIsInvalid() ? 'Required' : '', isAddressInvalid: firstAddressInvalid(), isSuiteAptNumberInvalid: firstSuiteAptNumberInvalid(), isCityInvalid: firstCityInvalid(), isStateInvalid: firstStateInvalid(), isZipInvalid: firstZipInvalid(), addressValue: firstAddressField.value, suiteAptNumberValue: firstSuiteAptNumberField.value, cityValue: firstCityField.value, stateValue: firstStateField.value, zipValue: firstZipField.value, onAddressChange: firstAddressFieldHelper.setValue, onAddressBlur: firstAddressField.onBlur, onSuiteAptNumberChange: firstSuiteAptNumberFieldHelper.setValue, onSuiteAptNumberBlur: firstSuiteAptNumberField.onBlur, onCityChange: firstCityFieldHelper.setValue, onCityBlur: firstCityField.onBlur, onStateChange: firstStateFieldHelper.setValue, onStateBlur: firstStateField.onBlur, onZipChange: firstZipFieldHelper.setValue, onZipBlur: firstZipField.onBlur }), secondAddressField: __assign(__assign({}, props.secondAddressField), { errorMessage: secondIsInvalid() ? 'Required' : '', isAddressInvalid: secondAddressInvalid(), isSuiteAptNumberInvalid: secondSuiteAptNumberInvalid(), isCityInvalid: secondCityInvalid(), isStateInvalid: secondStateInvalid(), isZipInvalid: secondZipInvalid(), addressValue: secondAddressField.value, suiteAptNumberValue: secondSuiteAptNumberField.value, cityValue: secondCityField.value, stateValue: secondStateField.value, zipValue: secondZipField.value, onAddressChange: secondAddressFieldHelper.setValue, onAddressBlur: secondAddressField.onBlur, onSuiteAptNumberChange: secondSuiteAptNumberFieldHelper.setValue, onSuiteAptNumberBlur: secondSuiteAptNumberField.onBlur, onCityChange: secondCityFieldHelper.setValue, onCityBlur: secondCityField.onBlur, onStateChange: secondStateFieldHelper.setValue, onStateBlur: secondStateField.onBlur, onZipChange: secondZipFieldHelper.setValue, onZipBlur: secondZipField.onBlur }) });
});
